(() => {
  const initialize = () => {
    document.querySelectorAll('.winter-quick-order').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const button = root.querySelector('[data-winter-add]');
      const status = root.querySelector('[data-winter-status]');
      if (!button || !status) return;

      button.addEventListener('click', async () => {
        const items = [...root.querySelectorAll('[data-winter-item]')]
          .filter((row) => row.querySelector('[data-winter-select]')?.checked)
          .map((row) => ({
            id: Number(row.dataset.variantId),
            quantity: Math.max(1, Number(row.querySelector('[data-winter-quantity]')?.value) || 1),
          }));

        if (!items.length) {
          status.textContent = 'Select at least one item.';
          return;
        }

        button.disabled = true;
        status.textContent = 'Adding selected pieces…';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error('Cart update failed');
          window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        } catch (error) {
          button.disabled = false;
          status.textContent = 'We could not add those items. Please try again.';
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', initialize);
})();
